import React from "react";
import PropTypes from "prop-types";
import { Link as ReactRouterLink } from "react-router-dom";
import PillBorder from "@default/general-components/pill-border";
import TypewriterAnimation from "../typewriter-animation";

/**
 * Use this to render links from Drupal - internal and external links are
 * differentiated based on the __typename of the URL.
 */
const Link = ({
  link,
  className,
  forceSameTab,
  ariaLabel,
  tabIndex,
  children,
  pill,
  hoverAnimation,
  ...rest
}) => {
  const mergedClassName = [className, hoverAnimation ? "action-element" : null]
    .filter(Boolean)
    .join(" ") || undefined;

  const text = children ? children : link.title;
  const content = hoverAnimation ? (
    <TypewriterAnimation>{text}</TypewriterAnimation>
  ) : text;

  return (
    <>
      {link?.uri?.path?.includes("/node/") ? null : (
        <>
          {link?.options?.href?.includes("/node/") || forceSameTab ? (
            <ReactRouterLink
              className={mergedClassName}
              to={link.uri.path}
              draggable="false"
              aria-label={ariaLabel || children || link.title}
              tabIndex={tabIndex}
              {...rest}
            >
              {pill && <PillBorder blurredBackdrop />}
              <span>{content}</span>
            </ReactRouterLink>
          ) : (
            <a
              className={mergedClassName}
              target="_blank"
              rel="noopener noreferrer"
              href={link?.uri?.path}
              draggable="false"
              aria-label={ariaLabel || children || link.title}
              tabIndex={tabIndex}
              {...rest}
            >
              {pill && <PillBorder blurredBackdrop />}
              <span>{content}</span>
            </a>
          )}
        </>
      )}
    </>
  );
};

export const LinkPropType = PropTypes.shape({
  uri: PropTypes.shape({
    __typename: PropTypes.string,
    path: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
});

Link.propTypes = {
  className: PropTypes.string,
  link: LinkPropType.isRequired,
  forceSameTab: PropTypes.bool,
  hoverAnimation: PropTypes.bool,
};

export default Link;
